module.exports = __webpack_public_path__ + "img/Light_off.0a06e084.png";